export default __webpack_public_path__ + "static/media/bu-yati.0eacf02b.png";